const resources = {
    popularOffers: 'Popular Offers',
    signIn: 'Sign in',
    signInSubtitle: 'to unlock exclusive offers'
};

export default function getResource(label) {
    return resources[label];
}
